// Campus photo for /colleges/university-of-nevada-las-vegas: CC BY-SA 4.0, by Mikerussell, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUNLV_campus.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-nevada-las-vegas/; credited under the photo.
const photo = {
    "slug": "university-of-nevada-las-vegas",
    "alt": "A walkway and lawn on the campus of the University of Nevada, Las Vegas",
    "src": "/colleges/university-of-nevada-las-vegas/campus-1600.webp",
    "srcSmall": "/colleges/university-of-nevada-las-vegas/campus-800.webp",
    "srcMid": "/colleges/university-of-nevada-las-vegas/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-nevada-las-vegas/og.jpg",
    "title": "UNLV campus",
    "author": "Mikerussell",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUNLV_campus.jpg",
    "read": "2026-10-01"
};

export default photo;
